import { GetFutureDeliveries, serializeDTO } from '@cloudsuite/cs-ordering-defs'
import { FutureDelivery } from './future-deliveries-types.js'
import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { executeOrderingRequest } from 'components/ordering/executor.js'
import { parseFutureDeliveriesResponse } from 'components/ordering/checkout/future-deliveries/api/future-deliveries-parser.js'

export const FUTURE_DELIVERIES_FETCHER = Symbol('FUTURE_DELIVERIES_FETCHER')

export interface FutureDeliveriesFetcher {
  getFutureDeliveries(request: GetFutureDeliveries): Promise<FutureDelivery[]>
}

@registerDependency(FAKE, FUTURE_DELIVERIES_FETCHER)
export class FakeFutureDeliveriesFetcher implements FutureDeliveriesFetcher {
  public futureDeliveries: Map<string, FutureDelivery[]> = new Map()

  async getFutureDeliveries(request: GetFutureDeliveries): Promise<FutureDelivery[]> {
    return this.futureDeliveries.get(serializeDTO(request)) || []
  }

  insertDeliveryDate(request: GetFutureDeliveries, deliveryDate: string) {
    const futureDeliveries = this.futureDeliveries.get(serializeDTO(request)) || []
    futureDeliveries.push(new FutureDelivery(new Date(deliveryDate)))
    this.futureDeliveries.set(serializeDTO(request), futureDeliveries)
  }
}

@registerDependency(REAL, FUTURE_DELIVERIES_FETCHER)
export class RealFutureDeliveriesFetcher implements FutureDeliveriesFetcher {
  async getFutureDeliveries(request: GetFutureDeliveries): Promise<FutureDelivery[]> {
    const response = await executeOrderingRequest(request)
    return parseFutureDeliveriesResponse(response)
  }
}
